import React, { useEffect, useState } from 'react';

import SelectDocumentType from '../..//../components/Selects/SelectDocumentType';
import { textStyles } from '../..//../constants/textStyles';
import Button from '../..//../components/Button/Button';
import DocsInputNew from '../..//../components/Inputs/DocsInput/DocsInputNew';
import uploadDocumentToDeal from '../..//../api/deals/uploadDocumentToDeal';
import Loader from '../..//../components/Loader/Loader';
import LoaderInline from '../../../components/Loader/LoaderInline';
import UploadProgressBar from '../../../components/UploadProgressBar';
import useDocumentUpload from '../../../hooks/useDocumentUpload';
import {
  DEAL_STATUS_CAR_ISSUED,
  DEAL_STATUS_CONTRACT_SIGNED,
  DEAL_STATUS_NOTARIAL_DOCUMENTS_UPLOADED,
  DEAL_STATUS_WAITING_FOR_NOTARIAL_DOCUMENTS,
  DEAL_STATUS_WAITING_FOR_REGISTRATION_BY_CLIENT,
  DOCUMENT_STATUS_SIGNED,
  DOCUMENT_TYPES_CONTRACT,
  DOCUMENT_TYPES_INVOICE,
  DOCUMENT_TYPES_OPTIONS,
  DOCUMENT_TYPES_POWER_OF_ATTORNEY,
  DOCUMENT_TYPES_SPOUSE_CONSENT,
  DOCUMENT_TYPES_TECH_PASSPORT,
  PAYMENT_STATUS_PAID,
  PAYMENT_TYPES_CREDIT_CARD,
  PAYMENT_TYPES_CREDIT_INVOICE,
  PAYMENT_TYPES_PREPAYMENT_CARD,
} from '../../../constants';
import alert from '../../../helpers/alert';
import editDeal from '../../../api/deals/editDeal';
import generateLink from '../../../api/signature/generateLink';
import { socket } from '../../../App';
import setStep from '../../../api/deals/setStep';
import Select from '../../../components/Select/Select';
import Modal from '../../../components/Modal/Modal';
import getOgpoLink from '../../../api/shop/getOgpoLink';
import AddButton from '../../../components/AddButton/AddButton';
import { colors } from '../../../constants/colors';
import HookForm from '../../../components/HookForm/HookForm';
import generateAllowedDocumentsJson from '../../../utils/generateAllowedDocumentsJson';

const DealCreateDocs = ({
  onSubmit,
  documents,
  deal,
  noSubmit,
  title = 'ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ ÑÐ´ÐµÐ»ÐºÐ¸',
  setDocumentsForm,
  canSkip,
  update,
  backHandler,
  cars,
}) => {
  const [file, setFile] = useState(null);
  const [registrationType, setRegistrationType] = useState(null);
  const [uploadFileName, setUploadFileName] = useState('');
  const { upload: uploadWithProgress, uploading: uploadingContract, progress: uploadProgress } = useDocumentUpload();

  const saveDeal = () => {
    editDeal({
      id: deal?.id,
      statusId: registrationType?.value,
    })
      .then(() => {
        if (registrationType?.value === DEAL_STATUS_WAITING_FOR_REGISTRATION_BY_CLIENT) {
          setStep({
            dealId: deal?.id,
            step: 6,
          }).then(() => {
            update && update();
          });
        } else {
          update && update();
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const row = () => [
    {
      component: SelectDocumentType,
      name: 'fileTypeId',
      style: {
        width: '100%',
      },
      disabled: true,
      defaultValue: DOCUMENT_TYPES_OPTIONS?.find((i) => i.value === DOCUMENT_TYPES_CONTRACT),
    },
    {
      component: DocsInputNew,
      name: 'file',
      label: 'Ð¤Ð°Ð¹Ð» Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°',
      text: 'Ð¤Ð°Ð¹Ð» Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°',
      id: Math.random(),
      rules: {
        required: true,
      },
    },
  ];
  const [form, setForm] = useState([row()]);
  const [loading, setLoading] = useState(false);
  const [loadingPage, setLoadingPage] = useState(false);
  const [loadingSignButton, setLoadingSignButton] = useState(false);
  const [loadingPaymentButton, setLoadingPaymentButton] = useState(false);

  const isNotarialDocumentsUploaded = () => {
    if (!documents?.find((doc) => doc?.typeId === DOCUMENT_TYPES_POWER_OF_ATTORNEY)) {
      return false;
    }

    if (
      !documents?.find((doc) => doc?.typeId === DOCUMENT_TYPES_SPOUSE_CONSENT) &&
      (deal?.paymentType?.id === PAYMENT_TYPES_CREDIT_CARD || deal?.paymentType?.id === PAYMENT_TYPES_CREDIT_INVOICE)
    ) {
      return false;
    }

    return true;
  };

  useEffect(() => {
    if (setDocumentsForm) {
      const fields = form.map((i) => i.map((i) => i.value?.value || i.value));
      setDocumentsForm(
        fields.map((field) => ({
          dealId: deal?.id,
          fileTypeId: field[0],
          file: field[1],
        }))
      );
    }
  }, [form, setDocumentsForm, deal?.id]);

  const uploadContract = async (file) => {
    setLoading(true);
    setUploadFileName(file?.name || 'ÐÐ¾ÐºÑÐ¼ÐµÐ½Ñ');
    try {
      await uploadWithProgress({
        dealId: deal?.id,
        statusId: DOCUMENT_STATUS_SIGNED,
        fileTypeId: DOCUMENT_TYPES_CONTRACT,
        file: file,
        signed: true,
      });
      await editDeal({
        id: deal?.id,
        statusId: DEAL_STATUS_CONTRACT_SIGNED,
      });
      alert.success('ÐÐ¾Ð³Ð¾Ð²Ð¾Ñ ÑÑÐ¿ÐµÑÐ½Ð¾ Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½');
      update && update();
    } catch (err) {
      if (err) {
        alert.error('ÐÑÐ¸Ð±ÐºÐ° Ð·Ð°Ð³ÑÑÐ·ÐºÐ¸ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÐ°');
      }
    } finally {
      setLoading(false);
      setUploadFileName('');
    }
  };

  const isContractSigned = documents?.find(
    (i) => i?.typeId === DOCUMENT_TYPES_CONTRACT && i?.signed
  );
  const isDealPaid = deal?.statusPayment?.id === PAYMENT_STATUS_PAID;

  const onNext = () => {
    setLoading(false);
    setStep({
      dealId: deal?.id,
      step: 6,
    }).then(() => {
      update && update();
    });
  };
  const isContractSignedStep = async () => {
    setLoading(true);
    try {
      await editDeal({
        id: deal?.id,
        statusId: DEAL_STATUS_CONTRACT_SIGNED,
      })
      update && update();
    } catch (e) {
      alert.error(e);
    } finally {
      setLoading(false);
    }
  };

  const sendContractSms = () => {
    setLoadingSignButton(true);
    const contract = documents?.find((i) => i?.typeId === DOCUMENT_TYPES_CONTRACT);

    generateLink({
      url: contract?.url,
      name: 'docs',
      typeId: DOCUMENT_TYPES_CONTRACT,
      documentId: contract?.id,
      userId: contract?.userId,
      dealId: deal?.id,
    })
      .then(() => {
        alert.success('Ð¡ÐÐ¡ ÑÑÐ¿ÐµÑÐ½Ð¾ Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½Ð¾');
      })
      .catch(() => {
        alert.error('ÐÑÐ¸Ð±ÐºÐ° Ð¾ÑÐ¿ÑÐ°Ð²ÐºÐ¸ Ð¡ÐÐ¡');
      })
      .finally(() => {
        setLoadingSignButton(false);
      });
  };
  const sendPaymentSms = () => {
    setLoadingPaymentButton(true);
    editDeal({
      dealId: deal?.id,
      id: deal?.id,
      paymentTypeId: PAYMENT_TYPES_PREPAYMENT_CARD,
      statusId: deal?.status?.id,
    })
      .then(() => {
        alert.success('Ð¡ÐÐ¡ ÑÑÐ¿ÐµÑÐ½Ð¾ Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½Ð¾');
      })
      .catch(() => {
        alert.error('ÐÑÐ¸Ð±ÐºÐ° Ð¾ÑÐ¿ÑÐ°Ð²ÐºÐ¸ Ð¡ÐÐ¡');
      })
      .finally(() => {
        setLoadingPaymentButton(false);
      });
  };

  useEffect(() => {
    const contract = documents?.find((i) => i?.typeId === DOCUMENT_TYPES_CONTRACT);
    socket.on('listenSignatureAgreementDocumentInDeal' + contract?.id, (data) => {
      if (data?.success) {
        update && update();
      } else {
        // ÐÑÐºÐµÐ½Ð´ Ð¿ÑÐ¸ÑÑÐ»Ð°ÐµÑ Ð¿ÑÐ¸ÑÐ¸Ð½Ñ ÑÑÑÐ²Ð° â Ð¾Ð½Ð° Ð¿Ð¾Ð»ÐµÐ·Ð½ÐµÐµ Ð¾Ð±ÑÐµÐ¹ ÑÑÐ°Ð·Ñ. Ð¡Ð¾Ð¾Ð±ÑÐµÐ½Ð¸Ðµ
        // Ð²Ð¸ÑÐ¸Ñ, Ð¿Ð¾ÐºÐ° Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð½Ðµ Ð·Ð°ÐºÑÐ¾ÐµÑ: Ð¾Ð½ Ð¼Ð¾Ð³ Ð¾ÑÐ¾Ð¹ÑÐ¸ Ð¾Ñ ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑÐ°.
        alert.error(data?.message || 'ÐÑÐ¸Ð±ÐºÐ° Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ñ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°', {
          autoClose: false,
          closeOnClick: false,
        });
      }
    });

    return () => {
      socket.off('listenSignatureAgreementDocumentInDeal' + contract?.id);
    };
  }, [documents, update]);

  useEffect(() => {
    const listenerName = 'listenCreditCardPaymentChunk' + deal?.chunkId;
    socket.on(listenerName, (data) => {
      if (data?.success) {
        update && update();
      } else {
        alert.error('ÐÑÐ¸Ð±ÐºÐ° Ð¾Ð¿Ð»Ð°ÑÑ');
      }
    });

    return () => {
      socket.off(listenerName);
    };
  }, [deal?.chunkId, update]);

  useEffect(() => {
    const listenerName = 'listenToChangeDealStatus' + deal?.id;

    console.log('listenerName', listenerName);
    socket.on(listenerName, (data) => {
      console.log('listenerName DATA', data);

      update && update();
    });
    return () => {
      socket.off(listenerName);
    };
  }, [deal, update]);

  const [ogpoModal, setOgpoModal] = useState(false);
  const [modalOGPO, setModalOGPO] = useState(false);
  const [ogpoLink, setOgpoLink] = useState(null);
  const [ogpoLoading, setOgpoLoading] = useState(false);

  const openOGPO = () => {
    setOgpoLoading(true);
    getOgpoLink(cars[0]?.orderId)
      .then((res) => {
        if(res.data?.errorMessage) {
          return alert.error(res.data?.errorMessage);
        }
        setOgpoLink(res?.data);
        setOgpoModal(true);
        setModalOGPO(false);
      })
      .catch((err) => {
        alert.error('ÐÑÐ¸Ð±ÐºÐ° Ð¿ÑÐ¸ Ð¿Ð¾Ð»ÑÑÐµÐ½Ð¸Ð¸ ÑÑÑÐ»ÐºÐ¸ Ð¿Ð¾ÐºÑÐ¿ÐºÐ¸ ÐÐÐÐ');
      })
      .finally(() => {
        setOgpoLoading(false);
      });
  };

  const onNotarialDocsSubmit = async (values) => {
    setLoading(true);

    if (!values['Ð´Ð¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÑ']) {
      alert.error('ÐÐ°Ð³ÑÑÐ·Ð¸ÑÐµ Ð´Ð¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÑ Ð½Ð° Ð¿Ð¾ÑÑÐ°Ð½Ð¾Ð²ÐºÑ Ð½Ð° ÑÑÐµÑ');
      setLoading(false);
      return;
    }

    setUploadFileName(values['Ð´Ð¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÑ']?.name || 'ÐÐ¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÑ');
    try {
      await uploadWithProgress({
        dealId: deal?.id,
        fileTypeId: DOCUMENT_TYPES_POWER_OF_ATTORNEY,
        file: values['Ð´Ð¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÑ'],
      });
      await editDeal({
        id: deal?.id,
        dealId: deal?.id,
        statusId: DEAL_STATUS_NOTARIAL_DOCUMENTS_UPLOADED,
        power_of_attorney_number: values?.powerOfAttorneyNumber
          ? values?.powerOfAttorneyNumber
          : deal?.power_of_attorney_number,
        ...generateAllowedDocumentsJson([
          DOCUMENT_TYPES_INVOICE,
          DOCUMENT_TYPES_POWER_OF_ATTORNEY,
          DOCUMENT_TYPES_CONTRACT,
          DOCUMENT_TYPES_TECH_PASSPORT,
        ]),
      });
      update();
    } catch (err) {
      alert.error('ÐÑÐ¸Ð±ÐºÐ° Ð·Ð°Ð³ÑÑÐ·ÐºÐ¸ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°');
    } finally {
      setLoading(false);
      setUploadFileName('');
    }
  };

  if (uploadingContract) {
    return <UploadProgressBar progress={uploadProgress} fileName={uploadFileName} />;
  }

  if (loading) {
    return (
      <div style={{ padding: '10px 20px', backgroundColor: 'white', marginTop: '20px', border: '1px solid #E0E0E0' }}>
        <LoaderInline />
      </div>
    );
  }

  return (
    <>
      {loadingPage ? (
        <Loader />
      ) : (
        <div>
          <div style={{ display: 'flex', alignItems: 'center', columnGap: '20px', marginTop: 20, marginBottom: 20 }}>
            <p style={textStyles.formTitle}>{title}</p>
          </div>
          <div style={{ marginBottom: 40 }}>
            {documents?.map((document) => (
              <a
                href={document?.url}
                target="_blank"
                style={{
                  gap: 7,
                  display: 'grid',
                  gridTemplateColumns: 'auto 1fr',
                  alignItems: 'center',
                  marginBottom: 20,
                }}
                rel="noreferrer"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
                  <path
                    d="M2 16H18V9H20V17C20 17.2652 19.8946 17.5196 19.7071 17.7071C19.5196 17.8946 19.2652 18 19 18H1C0.734784 18 0.48043 17.8946 0.292893 17.7071C0.105357 17.5196 0 17.2652 0 17V9H2V16ZM12 6H17L10 13L3 6H8V0H12V6Z"
                    fill="var(--brand-primary)"
                  />
                </svg>
                <a style={{ color: 'var(--brand-primary)', fontSize: 16, fontWeight: 400 }}>
                  {document?.type?.title} - {document?.url?.split('/')?.pop()}
                </a>
              </a>
            ))}
          </div>

          {form?.length > 0 && !noSubmit && !isContractSigned && isDealPaid && (
            <div style={{ display: 'flex', alignItems: 'center', columnGap: '20px', marginTop: 20, marginBottom: 20 }}>
              <p style={textStyles.formTitle}>ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð½ÑÐ¹ Ð´Ð¾Ð³Ð¾Ð²Ð¾Ñ </p>
            </div>
          )}
          {deal?.power_of_attorney_number && (
            <>
              <div
                style={{ display: 'flex', alignItems: 'center', columnGap: '20px', marginTop: 20, marginBottom: 20 }}
              >
                <p style={textStyles.formTitle}>ÐÐ¾Ð¼ÐµÑ Ð´Ð¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÐ¸:</p>
              </div>
              <div
                style={{
                  border: '1px solid #6A6A6A',
                  textTransform: 'uppercase',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: 10,
                  ...textStyles.fieldLabel,
                }}
              >
                {deal?.power_of_attorney_number}
              </div>
            </>
          )}
          {!isContractSigned && isDealPaid && (
            <div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
                <SelectDocumentType
                  style={{ width: '100%' }}
                  defaultValue={DOCUMENT_TYPES_OPTIONS?.find((i) => i.value === DOCUMENT_TYPES_CONTRACT)}
                  disabled={true}
                />
                <DocsInputNew
                  label="Ð¤Ð°Ð¹Ð» Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°"
                  text="Ð¤Ð°Ð¹Ð» Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°"
                  name="fileTypeId"
                  id="file"
                  onChange={uploadContract}
                  disabled={uploadingContract}
                />
              </div>
            </div>
          )}

          {/* <AddButton text="ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ ÐµÑÐµ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ" onClick={addRow} /> */}
          {
            deal?.status?.id !== DEAL_STATUS_CONTRACT_SIGNED && deal?.status?.id !== DEAL_STATUS_WAITING_FOR_NOTARIAL_DOCUMENTS
            && deal?.status?.id !== DEAL_STATUS_NOTARIAL_DOCUMENTS_UPLOADED ? 
              <>
                <div style={{ display: 'flex', alignItems: 'center', columnGap: '20px', marginTop: 20, marginBottom: 20 }}>
                  <p style={textStyles.formTitle}>ÐÐ¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ðµ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÐ° on-line</p>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
                  {isDealPaid && (
                    <>
                      <Button text="ÐÑÐ¿ÑÐ°Ð²Ð¸ÑÑ Ð´Ð¾Ð³Ð¾Ð²Ð¾Ñ" fill onClick={sendContractSms} disabled={loadingSignButton} />
                      <div
                        style={{
                          border: '1px solid #6A6A6A',
                          textTransform: 'uppercase',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          ...textStyles.fieldLabel,
                        }}
                      >
                        {isContractSigned ? 'ÐÐ¾Ð´Ð¿Ð¸ÑÐ°Ð½' : 'ÐÐµ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½'}
                      </div>
      
                      <Button text="ÐÐ°Ð»ÐµÐµ" fill onClick={isContractSignedStep} disabled={loadingSignButton} />
                    </>
                  )}
                </div>
              </> : null
          }
          {isDealPaid &&
            isContractSigned &&
            !isNotarialDocumentsUploaded() &&
            deal?.status?.id === DEAL_STATUS_WAITING_FOR_NOTARIAL_DOCUMENTS && (
              <div>
                <HookForm
                  title={'ÐÐ°Ð³ÑÑÐ·ÐºÐ° Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ¾Ð²'}
                  hint="ÐÑÐ¾ÐºÐ¾Ð½ÑÑÐ»ÑÑÐ¸ÑÑÐ¹ÑÐµ ÐºÐ»Ð¸ÐµÐ½ÑÐ° ÐºÐ°ÐºÐ¸Ðµ Ð¸Ð¼ÐµÐ½Ð½Ð¾ Ð´Ð¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÐ¸ Ð¸ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ñ Ð½Ð°Ð´Ð¾ ÑÐ´ÐµÐ»Ð°ÑÑ. ÐÑÐ¶Ð½Ð¾ ÑÑÐ¾Ð±Ñ ÐºÐ»Ð¸ÐµÐ½Ñ Ð·Ð°Ð¿ÑÐ°ÑÐ¸Ð²Ð°Ð» ÑÐ°Ð²Ð½Ð¾Ð·Ð½Ð°ÑÐ½Ð¾ÑÑÑ Ð´Ð¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÐ¸, ÑÑÐ¾ Ð½ÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð´Ð»Ñ ÑÐ¾Ð³Ð¾, ÑÑÐ¾Ð±Ñ Ð¼Ð¾Ð¶Ð½Ð¾ Ð±ÑÐ»Ð¾ Ð²ÑÐ¿Ð¸ÑÐ°ÑÑ Ð´Ð¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÑ Ñ Ð»ÑÐ±Ð¾Ð³Ð¾ Ð½Ð¾ÑÐ°ÑÐ¸ÑÑÐ°.   Ð¢Ð°Ðº Ð¶Ðµ Ð½ÑÐ¶Ð½Ð¾ Ð¾Ð¿Ð¸ÑÐ°ÑÑ Ð½Ð° ÐºÐ¾Ð³Ð¾ Ð½ÑÐ¶Ð½Ð¾ ÑÐ´ÐµÐ»Ð°ÑÑ Ð´Ð¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÑ Ð½Ð° Ð¿Ð¾ÑÑÐ°Ð½Ð¾Ð²ÐºÑ Ð½Ð° ÑÑÐµÑ. ÐÑÐ¿Ð¸ÑÐ°ÑÑ Ð´Ð¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÑ Ð½Ð° ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ð¾Ð½Ð½ÑÐµ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ñ Ð½ÑÐ¶Ð½Ð¾ Ð½Ð° Ð¤ÐÐ, ÐÐÐ ÑÐµÐ»Ð¾Ð²ÐµÐºÐ°."
                  grid={{ display: 'grid', gap: 20 }}
                  action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ'}
                  inputs={[
                    {
                      text: 'ÐÐ¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÑ Ð¿Ð¾ÑÑÐ°Ð½Ð¾Ð²ÐºÐ¸ Ð½Ð° ÑÑÐµÑ',
                      label: 'ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ',
                      name: 'Ð´Ð¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÑ',
                      id: 'ÐÐ¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÑ Ð¿Ð¾ÑÑÐ°Ð½Ð¾Ð²ÐºÐ¸ Ð½Ð° ÑÑÐµÑ',
                      component: DocsInputNew,
                      required: true,
                    },
                    {
                      label: 'ÐÐ¾Ð¼ÐµÑ Ð´Ð¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÐ¸',
                      name: 'powerOfAttorneyNumber',
                    },
                  ]}
                  onSubmit={onNotarialDocsSubmit}
                  loading={loading || uploadingContract}
                />
              </div>
            )}
          {isDealPaid && isContractSigned && deal?.status?.id === DEAL_STATUS_CONTRACT_SIGNED && (
            <div style={{ marginBottom: 10 }}>
              <Select
                label="Ð ÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ñ Ð¢Ð¡"
                placeholder={'ÐÑÐ±ÐµÑÐ¸ÑÐµ ÑÐ¸Ð¿ ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ð¸ Ð¢Ð¡'}
                options={[
                  {
                    value: DEAL_STATUS_WAITING_FOR_REGISTRATION_BY_CLIENT,
                    label: 'ÐÐ»Ð¸ÐµÐ½Ñ ÑÐ´ÐµÐ»Ð°ÐµÑ ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ñ Ð¢Ð¡ ÑÐ°Ð¼Ð¾ÑÑÐ¾ÑÑÐµÐ»ÑÐ½Ð¾',
                  },
                  {
                    value: DEAL_STATUS_WAITING_FOR_NOTARIAL_DOCUMENTS,
                    label: 'Ð ÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ñ Ð¢Ð¡ Ð±ÑÐ´ÐµÑ Ð¿ÑÐ¾Ð¸Ð·Ð²Ð¾Ð´Ð¸ÑÑ Doscar',
                  },
                ]}
                onChange={setRegistrationType}
              />
            </div>
          )}

          <Modal
            isOpen={modalOGPO}
            onRequestClose={() => {
              setModalOGPO(false);
            }}
            width={460}
            contentStyle={{ height: 'auto', inset: '20% 40px auto 350px' }}
          >
            {ogpoLoading ? (
              <LoaderInline />
            ) : (
              <>
                <h3
                  style={{
                    ...textStyles.formTitle,
                    color: colors.blackPearl,
                    textAlign: 'center',
                    padding: '0 70px',
                    lineHeight: '24px',
                    marginBottom: 30,
                  }}
                >
                  ÐÑ Ð±ÑÐ´ÐµÑÐµ Ð¿ÐµÑÐµÐ½Ð°Ð¿ÑÐ°Ð²Ð»ÐµÐ½Ñ Ð½Ð° ÑÐ°Ð¹Ñ <span style={{ color: colors?.cameo }}>Basel.kz</span> Ð´Ð»Ñ Ð¿ÑÐ¾ÑÑÐµÑÐ°
                  ÑÑÐ¾Ð¸Ð¼Ð¾ÑÑÐ¸ Ð¸ Ð¿Ð¾ÐºÑÐ¿ÐºÐ¸ ÑÑÑÐ°ÑÐ¾Ð²ÐºÐ¸ ÐÐÐÐ
                </h3>
                <p style={{ marginBottom: 30, textAlign: 'center' }}>
                  ÐÐ¾ÑÐ»Ðµ Ð¿Ð¾ÐºÑÐ¿ÐºÐ¸ Ð¿Ð¾Ð»Ð¸ÑÐ°, Ð²Ñ ÑÐ¼Ð¾Ð¶ÐµÑÐµ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ Ð¾ÑÐ¾ÑÐ¼Ð»ÐµÐ½Ð¸Ðµ ÑÐ´ÐµÐ»ÐºÐ¸
                </p>
                <Button text="ÐÐµÑÐµÐ¹ÑÐ¸" fill style={{ width: '100%' }} onClick={openOGPO} />
              </>
            )}
          </Modal>

          <Modal
            wrapperStyle={{
              height: '100%',
            }}
            isOpen={ogpoModal}
            onRequestClose={() => {
              setOgpoModal(false);
            }}
          >
            <iframe
              src={ogpoLink}
              style={{ height: '100%', width: '100%' }}
              frameborder="0"
              title="ÐÐ½Ð»Ð°Ð¹Ð½-Ð¿ÑÐ¾Ð´Ð°Ð¶Ð° ÑÑÑÐ°ÑÐ¾Ð²ÐºÐ¸ ÐÐÐÐ"
            ></iframe>
          </Modal>

          <div style={{ display: 'flex', gap: '20px', marginTop: '20px' }}>
            {(isNotarialDocumentsUploaded() || deal?.status?.id === DEAL_STATUS_WAITING_FOR_REGISTRATION_BY_CLIENT) && (
              <Button text="ÐÐ°Ð»ÐµÐµ" onClick={onNext} fill style={{ width: '140px' }} />
            )}
            {registrationType && <Button fill text="Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ" onClick={saveDeal} />}

            {backHandler && backHandler()}
          </div>
        </div>
      )}
    </>
  );
};

export default DealCreateDocs;
